import { Component, OnInit } from "@angular/core";
import { DataService } from "../../_service/data.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  test: any;
  loginData: any;
  isDIGMLogin: Boolean = false;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.getLoginDetails(params["email"], params["otp"], params["pass"]);
    });
    let loginData = this.dataService.getCookies("loginData")
      ? JSON.parse(this.dataService.getCookies("loginData"))
      : JSON.parse(localStorage.getItem("loginData"));

    // PAN India logins
    if (loginData && ["2", "3"].includes(loginData["user_role"]))
      this.isDIGMLogin = true;
   
  }

  public getLoginDetails(email, otp, pass) {
    if (!email) {
      this.dataService.showError("Email missing.");
    } else if (!pass) {
      this.dataService.showError("Password missing.");
    }
    
    else {
      this.dataService.startLoader();
      this.dataService
        .post("auth/login", {
          userEmail: email,
          password: pass,
          //  "otp": otp,
          sKeys: "1r2a3k4s5h6s7i8n9h10",
          reporting: 1,
        })
        .subscribe(
          (res) => {
            this.dataService.stopLoader();
            if (res["code"] == 200) {
              // console.log("login", res);
              res["data"].acl = {
                userType: res["data"].acl.ut,
                channel: res["data"].acl.c,
                region: res["data"].acl.r,
                zone: res["data"].acl.z,
                business_unit_id: res["data"].acl.cu,
                agl_flag: res["data"].acl.f,
                userEmail: email,
                user_role: res["data"].user_role,
              };
              this.loginData = res["data"];
              localStorage.setItem("loginData", JSON.stringify(res["data"]));
              this.dataService.setCookies("loginData", res["data"]);
            } else {
              this.dataService.showError(res["message"]);
              if (res["code"] == 401) {
                this.dataService.logout();
              }
            }
          },
          (err) => {
            this.dataService.stopLoader();
            this.dataService.showError(err);
          }
        );
    }
  }
}
